import { resolveGeo } from '@/utils/geo';
import { setEdgePhoneCountry } from '@/utils/phone';
import { defaultCurrencyCode } from '@/utils/intl';

/**
 * The currency every price is shown and charged in, plus the visitor's rough location, which is
 * used for example text in empty fields. Resolved once when the app starts, in parallel with
 * Firebase auth, so no screen waits for a round trip of its own.
 */
export default {
  namespaced: true,
  state: {
    code: defaultCurrencyCode,
    country: null,
    city: null,
    region: null,
    timezone: null,
    source: 'default',
    isResolved: false,
    isResolving: false,
  },
  mutations: {
    SET_CURRENCY(state, {
      currency, country, city, region, timezone, source,
    }) {
      state.code = currency;
      state.country = country;
      state.city = city || null;
      state.region = region || null;
      state.timezone = timezone || null;
      state.source = source;
      state.isResolved = true;
      state.isResolving = false;
    },
    SET_IS_RESOLVING(state, payload) {
      state.isResolving = payload;
    },
  },
  getters: {
    place: (state) => ({ city: state.city, region: state.region, country: state.country }),
  },
  actions: {
    async resolve({ commit, state }, profileCurrency) {
      // A currency stored on the profile arrives later than the first call and must win
      if (state.isResolving) return state.code;
      if (state.isResolved && !profileCurrency) return state.code;

      commit('SET_IS_RESOLVING', true);

      const geo = await resolveGeo(profileCurrency);
      commit('SET_CURRENCY', geo);
      setEdgePhoneCountry(geo.country);

      return geo.currency;
    },
  },
};
